import { useNavigate } from "react-router-dom"
import { useIndustriesTable } from "../hooks/useIndustriesTable"
import { useAuth } from "../../../context/auth-user"

import sortIcon from "../../../assets/images/sort.svg"
import moreDots from "../../../assets/images/moreDots.svg"

export function IndustriesTable() {
    const navigate = useNavigate()

    const { user } = useAuth()
	const userLogged = user?.selectedProfile
	const darkLightMode = userLogged?.darkLightMode

    const {
            data: allIndustries,
            handleSortChange,
            showIndustryOptionsMenu,
            handleShowIndustryOptionsMenu,
        } = useIndustriesTable()
    
    const mainStyle = {
		background: darkLightMode ? "#131E29" : "white",
		color: darkLightMode ? "white" : "inherit"
	}
    
    return (
        <>
            <table className="tableIndustry">
				<thead>
					<tr>
						<th style={mainStyle}>
							<span>Industry</span>
							<img 
								className="sort" 
								src={sortIcon} 
								alt="Prodensa supplier" 
								onClick={() => handleSortChange("name")} 
							/>
						</th>
						<th style={mainStyle}>
							<span>Qty. Suppliers</span>
							<img 
								className="sort" 
								src={sortIcon} 
								alt="Prodensa supplier" 
								onClick={() => handleSortChange("suppliersCount")} 
							/>
						</th>
					</tr>
				</thead>
				<tbody>
					{allIndustries.length === 0 && (
						<tr>
							<td colSpan={2} style={{ textAlign: "center", padding: "20px" }}>
								No industries found.
							</td>
						</tr>
					)}
					
					{allIndustries.map(industry => {
						return (
							<tr key={industry._id}>
								<td>
									<div className="infoContainer">
										<span onClick={() => navigate("./" + industry._id)}>
											{industry.name}
										</span>
									</div>
								</td>
								
								<td>
									<div className="infoContainer">
										<span>{industry.suppliersCount || 0}</span>
										
										<img 
											className="moreOptions" 
											src={moreDots} 
											onClick={(e) => handleShowIndustryOptionsMenu(e, industry.name)} 
											alt="Prodensa Supplier" 
										/>
										<div className={`industryOptions ${showIndustryOptionsMenu === industry.name ? "show" : ""} ${darkLightMode ? "darkMode" : null}`}>
											<span onClick={() => navigate("/home/suppliers/", {
												state: { industryName: industry.name }
											})}>
												View suppliers
											</span>
											<span onClick={() => navigate("./" + industry._id)}>
												Edit
											</span>
										</div>
									</div>
								</td>
							</tr>
						)
					})}
				</tbody>
			</table>

			<div className="d-lg-none industryInformation">
				{allIndustries.length === 0 && (
					<div style={{ textAlign: "center", padding: "20px" }}>
						No industries found.
					</div>
				)}
				
				{allIndustries.map(data => {
					return (
						<div key={data._id} className="industryRow">
							<h5 className="industryName">{data.name}</h5>
							<span className="industryTitle">Industry</span>
							<span className="industryValue">{data.suppliersCount || 0}</span>
							<span className="industryTitle">Qty. suppliers</span>
							<img 
								className="moreOptions" 
								src={moreDots} 
								onClick={(e) => handleShowIndustryOptionsMenu(e, data.name)} 
								alt="Prodensa Supplier" 
							/>
							<div className={`industryOptions ${showIndustryOptionsMenu === data.name ? "show" : ""} ${darkLightMode ? "darkMode" : null}`}>
								<span onClick={() => navigate("/home/suppliers/", {
									state: { industryName: data.name }
								})}>
									View suppliers
								</span>
								<span onClick={() => navigate("./" + data._id)}>
									Edit
								</span>
							</div>
						</div>
					)
				})}
			</div>
        </>
    )
}